import React, { Component } from 'react'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import SideBar from '../sidebar/sidebar'
import TopBar from '../topbar/topbar'
import white from '../assets/search.png'
import { Link } from 'react-router-dom'
import './economics.css';
import Axios from 'axios';
import ReactHtmlParser from 'react-html-parser'
import { BASE } from '../api/api';

class Economics extends Component {
    componentDidMount() {
        Axios.get(BASE + 'jsonapi/node/page?filter[title]=Islamic Economics %26 Finance')
            .then((res) => {
                this.setState({
                    econ: res.data.data
                })
            })
        console.log('econ', this.state.econ)
    }
    constructor(props) {
        super(props);
        this.state = {
            option: "Publication",
            option_show: false,
            keyword: '',
            searchfilter: '',
            econ: [],
            details: null
        };
    }
    fillalert(msg) {
        this.setState({
            filltext: msg,
            fillalert: true
        })
        setTimeout(
            function () {
                this.setState({
                    fillalert: null
                })
            }
                .bind(this),
            3000
        );
    }
    _handleKeyPress(e) {

        if (e.key === 'Enter') {
            this.search()
        }
    }
    search() {
        if (this.state.keyword.length < 3) {
            // alert("Enter atleast 3 characters")
            this.fillalert("Enter atleast 3 characters")

        }
        else
            // window.location.href = '/search/' + this.state.keyword.replace(/\//g, '%20').replace(',', '%20')
            this.props.history.push('/search/' + this.state.keyword.replace(/\//g, '%20').replace(',', '%20'))
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    render() {
        return (
            <div>
                <Header />
                <div className='container economics-page side-arrange' style={{ minHeight: '71.6vh' }}>
                    <SideBar data={'data2'} />
                    <div className='columns'>
                        <div className='top-contents'>
                            <div className="crumbs "><Link to='/'>Home</Link> / <Link to='/economics'>Islamic Economics {'&'} </Link></div>
                           
                        </div>

                        <div className="page-title">
                            <div className="title-wrapper">
                                <div className="">
                                    <h1 className="heading">{this.state.econ.length ? this.state.econ[0].attributes ? this.state.econ[0].attributes.title : '' : ""}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="main-content listing">
                            <div id="" className="content-p">
                                <div className="row">
                                    <div className="region region-content">
                                        <div className="">
                                            {this.state.econ.length ? this.state.econ[0].attributes ? this.state.econ[0].attributes.body ? ReactHtmlParser(this.state.econ[0].attributes.body.value) : '' : "" : ''}

                                        </div>
                                    </div>
                                </div>
                                {this.state.econ.length ? <div className="newsearchdiv">
                                    <input type="text" placeholder="Explore IEF Database" name="keyword" value={this.state.keyword} size="40" minLength="3" maxLength={120} onChange={e => { this.handleChange(e) }} onKeyPress={(e) => this._handleKeyPress(e)} style={{ borderRight: 'none' }} />
                                    <div className="newsearchicon">
                                        <img onClick={() => this.search()} src={white} alt='white' />
                                    </div>
                                </div>
                                    : ''}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='construct-footer'>
                    <Footer />
                </div>
            </div>
        )
    }
}
export default Economics;